import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./styles";
import { ErrorMessage } from "../error-message";
import DropdownChevron from "../../assets/dropdown-chevron-closed.svg?inline";

export const Select = ({
  items,
  onItemClick,
  initialValue,
  classname,
  ariaLabel,
  disabled,
  errorMessage,
  id,
  style,
  hasError,
}) => {
  return (
    <div>
      <select
        style={
          style
            ? style
            : {
                backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
                  DropdownChevron
                )}")`,
              }
        }
        className={classnames(
          styles.select,
          classname,
          hasError && styles.inputError
        )}
        onChange={(event) => {
          onItemClick && onItemClick(event);
        }}
        aria-label={ariaLabel}
        disabled={disabled}
        value={initialValue}
        autoComplete="off"
        id={id}
      >
        {items &&
          items.map((item) => (
            <option
              key={item.value || item.description}
              value={item.value}
              disabled={item.disabled}
            >
              {item.description}
            </option>
          ))}
      </select>
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
};

Select.propTypes = {
  /**
   Array of items used to populate the Select element
  */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      description: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }).isRequired
  ).isRequired,
  /**
   Callback that returns event.target, itemClicked and openState
  */
  onItemClick: PropTypes.func,
  /**
   The initial item to set the Select with
  */
  initialValue: PropTypes.string,
  /**
   Allows you to add additional classes to the accordion
  */
  classname: PropTypes.string,
  ariaLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  style: PropTypes.object,
};

Select.defaultProps = {
  selectIndexOnMount: 0,
  className: "",
  initialValue: "",
  errorMessage: "",
  id: "",
  style: null,
  hasError: false,
};
